// extracted by mini-css-extract-plugin
module.exports = {"ModalWrapper":"Modal_ModalWrapper__2_c9t","Modal":"Modal_Modal__2dfOw","CloseButton":"Modal_CloseButton__2gR_r"};